module.exports = __webpack_public_path__ + "img/frame (219).3267e2c7.jpg";